import { Box, SxProps, Theme, Typography } from '@mui/material';
import theme from '@shared/themes/darkTheme';

export const MIGRATION_BANNER_HEIGHT = 32;

export const FLUX_4_URL = 'https://www.fluxenergy.live/';
export const SUPPORT_MAILTO = 'mailto:support@flux.live';

// Shared white pill style so both CTA buttons match exactly.
const ctaButtonSx: SxProps<Theme> = {
  backgroundColor: '#FFFFFF',
  color: theme.palette.text.dark,
  fontSize: 12,
  fontWeight: 700,
  lineHeight: 1.2,
  whiteSpace: 'nowrap',
  textDecoration: 'none',
  borderRadius: 1,
  px: 1,
  py: 0.375,
  '&:hover': {
    backgroundColor: '#E0E0E0',
  },
};

export const MigrationBanner = () => {
  return (
    <Box
      sx={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        height: MIGRATION_BANNER_HEIGHT,
        zIndex: theme.zIndex.drawer + 1,
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.text.primary,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 1,
        px: 2,
        textAlign: 'center',
        flexWrap: 'nowrap',
        overflow: 'hidden',
      }}
    >
      <Typography variant="body2" noWrap sx={{ minWidth: 0, fontSize: { xs: 11, sm: 13 }, lineHeight: 1.2 }}>
        Flux 3.0 is retiring in September switch to <strong>Flux 4.0</strong>, now faster and more advanced.
      </Typography>
      <Box component="a" href={FLUX_4_URL} target="_blank" rel="noopener noreferrer" sx={ctaButtonSx}>
        Upgrade Now
      </Box>
      {/* Walkthrough / support section — hidden on very narrow screens to avoid overflow */}
      <Box sx={{ display: { xs: 'none', sm: 'flex' }, alignItems: 'center', gap: 1 }}>
        <Box sx={{ width: '1px', height: 16, backgroundColor: 'rgba(255, 255, 255, 0.4)' }} />
        <Typography variant="body2" noWrap sx={{ fontSize: 13, lineHeight: 1.2 }}>
          Need a walkthrough?
        </Typography>
        <Box component="a" href={SUPPORT_MAILTO} sx={ctaButtonSx}>
          Contact Support
        </Box>
      </Box>
    </Box>
  );
};
